module.exports = __webpack_public_path__ + "static/media/id11-ritas.e2e9262a.jpg";